import { useState } from "react";
import { Outlet, useLocation } from "react-router";
import { css } from "styled-system/css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";

export function RootLayout() {
  // Below md the sidebar is a drawer. It remembers the path it was opened
  // on, so a route change closes it.
  const location = useLocation();
  const [navOpenOn, setNavOpenOn] = useState<string | null>(null);
  const navOpen = navOpenOn === location.pathname;
  const setNavOpen = (open: boolean) =>
    setNavOpenOn(open ? location.pathname : null);

  return (
    <div className={styles.container}>
      <Sidebar open={navOpen} />
      {navOpen && (
        <div
          className={styles.scrim}
          onClick={() => setNavOpen(false)}
          aria-hidden
        />
      )}
      <div className={styles.main}>
        <Header onMenu={() => setNavOpen(!navOpen)} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    minHeight: "100vh",
    bg: "bg.canvas",
  }),
  scrim: css({
    position: "fixed",
    inset: 0,
    bg: "rgba(18,18,18,0.35)",
    zIndex: 40,
    display: { base: "block", md: "none" },
  }),
  main: css({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    minHeight: "100vh",
  }),
  content: css({
    flex: 1,
    p: { base: 4, md: 6 },
    minWidth: 0,
  }),
};
